import React, { Component } from 'react';
import RheoStatAirBb from 'rheostat';
import './normal_hours_slider.css';
let range = "";

class MyProgress extends Component {
  

    render() {
        return (
            <div
                {...this.props}
                style={{
                ...this.props.style,
                backgroundColor: '#bbce36',
              //  cursor: 'ew-resize',
                height: 24,
                zIndex: 2,
                paddingRight: 20,
                marginLeft: -8
                }}
            >
            <span className={"progressText"}>{range}</span>
            
            </div>
        );
    } 
}

class MyHandle extends Component {
  

    convertTo12(timein24) {
        var rounded_value = Math.ceil(timein24/15)*15
         let hours = Math.floor(rounded_value / 60),
             minutes = rounded_value - (hours * 60),
             AMPM = hours >= 12 ? " PM" : " AM" ;
         hours = hours >= 13 ? hours - 12 : (hours < 1 ? hours + 12 : hours); 
         minutes = minutes < 10 ? "0" + minutes : minutes;
         return hours + ":" + minutes + AMPM;
     }
     
    render() {
       
        if(this.props['data-handle-key']===0){
            range = this.convertTo12(this.props['aria-valuenow']) + " - " + this.convertTo12(this.props["aria-valuemax"]);
        }

        return (
            <div
                {...this.props}
                style={{
                ...this.props.style,
               backgroundColor: 'transparent',
                border: '1px solid black',
                cursor: 'ew-resize',
                height: 18,
                width: 4,
                zIndex: 3,
                top: 5
                }}
            >
            {/* <span className={"progressText"}>{range}</span> */}
            </div>
        );
    }
} 



class TimeCustomization extends Component {
    constructor(props) {
        super(props);
        this.state = {
          values: props.values || [0],
        };
    
        this.updateValue = this.updateValue.bind(this);
    }

    updateValue(sliderState) {

        this.setState({
          values: sliderState.values,
        });
        
    }
    render() {
        let l_sliderdata = this.props.values || [0];
        return (
            <div>
                <RheoStatAirBb {...this.props} 
                     onValuesUpdated={this.updateValue} 
                    values={l_sliderdata} 
                    progressBar = {MyProgress}
                    handle={MyHandle}
                     ref="mainDiv"
                />
            </div>
        );
    }
}


export default TimeCustomization;